import React from "react";
import "./banner.scss";

import { getBannerSentiment, getBannerMessage } from "./bannerUtils";
import { hideGlobalBanner } from "../../actions/globalActions";
import Banner from "./banner";
import { useAppSelector, useAppDispatch } from "../../hooks";

export default function GlobalBanner() {
  const { bannerType, isBannerVisible } = useAppSelector(state => state.global);
  const dispatch = useAppDispatch();

  const onBannerClose = () => {
    dispatch(hideGlobalBanner());
  };

  const sentiment = getBannerSentiment(bannerType);
  const message = getBannerMessage(bannerType);

  return (
    <div className="global-banner">
      <Banner
        isBannerVisible={isBannerVisible}
        shouldShowBannerClose={true}
        sentiment={sentiment}
        message={message}
        onBannerClose={onBannerClose}
      />
    </div>
  );
}
